<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">PÁGINAS DE APP</h1>
        </section>

        <section id="body">
            <form [formGroup]="pagesForm" (ngSubmit)="saveChanges(pagesForm.value)">
                <h2 class="cardHeader">Acerca de nosotros</h2>
                <mat-card>
                  <h4>Descripción</h4>
                  <quill-editor formControlName="about" [modules]="quillConfiguration" [styles]="{height: '10rem'}"
                                [placeholder]="'Ingrese texto...'">
                  </quill-editor>
                  <mat-form-field appearance="outline">
                    <mat-label>Imagen</mat-label>
                    <ngx-mat-file-input formControlName="aboutImg" accept=".png, .jpeg, .jpg">
                    </ngx-mat-file-input>
                  </mat-form-field>
                  <img class="image-preview" [src]="DsAboutImg" />
                </mat-card>
                <h2 class="cardHeader">Cómo funciona</h2>
                <mat-card>
                  <h4>Descripción</h4>
                  <quill-editor formControlName="how" [modules]="quillConfiguration"
                                [styles]="{height: '10rem'}" [placeholder]="'Ingrese texto...'">
                  </quill-editor>
                  <mat-form-field appearance="outline">
                    <mat-label>Imagen</mat-label>
                    <ngx-mat-file-input formControlName="howImg" accept=".png, .jpg, .jpeg">
                    </ngx-mat-file-input>
                  </mat-form-field>
                  <img class="image-preview" [src]="DsHowImg" />

                </mat-card>
                <h2 class="cardHeader">Preguntas frecuentes</h2>
                <mat-card>
                    <h4>Descripción</h4>
                    <quill-editor formControlName="faq" [modules]="quillConfiguration" [styles]="{height: '10rem'}"
                        [placeholder]="'Ingrese texto...'">
                    </quill-editor>
                </mat-card>
                <h2 class="cardHeader">Contacto</h2>
                <mat-card>
                    <h4>Descripción</h4>
                    <quill-editor formControlName="contact" [modules]="quillConfiguration" [styles]="{height: '10rem'}"
                        [placeholder]="'Ingrese texto...'">
                    </quill-editor>
                </mat-card>
                <br>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-flat-button type="submit" [disabled]="!pagesForm.valid" class="save-changes">GUARDAR
                        CAMBIOS</button>
                        <button routerLink="/admin-home" mat-raised-button class="cancel-changes">CANCELAR</button>
                </div>
            </form>
        </section>

    </div>
</div>
